import { render } from "./building-block-card.vue?vue&type=template&id=16f2f03c&lang=pug"
import script from "./building-block-card.vue?vue&type=script&lang=js"
export * from "./building-block-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__